<template>
  <el-card class="contract-item" shadow="never">
    <div class="contract-header" @click="toggleCollapse">
      <span class="contract-title">
        合同有效期：{{ contract.contractOn }} ~ {{ contract.contractOff }}
        <span v-if="isCurrentValid" class="status active"> 有效 </span>
      </span>
      <el-button v-if="mode === 'view'" type="default" plain size="small" @click.stop="edit"
        >编辑</el-button
      >
      <el-button v-if="mode === 'edit'" type="primary" size="small" @click.stop="save"
        >保存</el-button
      >
      <el-button v-if="mode === 'edit'" type="default" plain size="small" @click.stop="cancel"
        >取消</el-button
      >
      <el-button
        v-if="mode === 'edit' && !contract.id"
        type="default"
        plain
        size="small"
        @click.stop="deleteItem"
        >删除</el-button
      >
      <span class="arrow-icon" :class="{ rotated: expanded }">&#9660;</span>
    </div>
    <el-collapse-transition>
      <div v-show="expanded" class="contract-body">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="rules"
          label-width="160px"
          :disabled="mode === 'view'"
          size="small"
        >
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="合同签订日期" prop="signDate" label-width="160px">
                <el-date-picker
                  v-model="formData.signDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期时间"
                />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="合同有效期起" prop="contractOn" label-width="160px">
                <el-date-picker
                  v-model="formData.contractOn"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同有效期止" prop="contractOff" label-width="160px">
                <el-date-picker
                  v-model="formData.contractOff"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="押金" prop="deposit" label-width="160px">
                <el-input-number v-model="formData.deposit" :min="0" style="width: 220px" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保底积分" prop="basePoints" label-width="160px">
                <el-input-number v-model="formData.basePoints" :min="0" style="width: 220px" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="每月休息天数" prop="maxLeaveDaysPerMonth" label-width="160px">
                <el-input-number
                  v-model="formData.maxLeaveDaysPerMonth"
                  :min="0"
                  :max="31"
                  style="width: 220px"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保底收入" prop="baseSalary" label-width="160px">
                <el-input-number v-model="formData.baseSalary" :min="0" style="width: 220px" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="合作协议" prop="pdfOfContact" label-width="160px">
                <file-upload uploadType="choose" v-model="formData.pdfOfContact" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="租赁合同" prop="pdfOfLeaseContact" label-width="160px">
                <file-upload uploadType="choose" v-model="formData.pdfOfLeaseContact" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="补充协议" prop="pdfOfAdditionalAgreement" label-width="160px">
                <file-upload uploadType="choose" v-model="formData.pdfOfAdditionalAgreement" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="押金借条" prop="pdfOfLoanNote" label-width="160px">
                <file-upload uploadType="choose" v-model="formData.pdfOfLoanNote" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item
                label="委托付款承诺书"
                prop="pdfOfCommitmentOfPayment"
                label-width="160px"
              >
                <file-upload uploadType="choose" v-model="formData.pdfOfCommitmentOfPayment" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item
                label="从业资格证承诺书"
                prop="pdfOfCommitmentOfQualifications"
                label-width="160px"
              >
                <file-upload
                  uploadType="choose"
                  v-model="formData.pdfOfCommitmentOfQualifications"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="车辆风险告知书"
                prop="pdfOfRiskNotificationOfVehicle"
                label-width="160px"
              >
                <file-upload
                  uploadType="choose"
                  v-model="formData.pdfOfRiskNotificationOfVehicle"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="签约风险告知书"
                prop="pdfOfRiskNotificationOfContract"
                label-width="160px"
              >
                <file-upload
                  uploadType="choose"
                  v-model="formData.pdfOfRiskNotificationOfContract"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24"> </el-row>
        </el-form>

        <div class="indicator-section">
          <div class="indicator-header">
            <span>司机指标管理</span>
            <div v-if="mode === 'edit'">
              <el-button type="primary" size="mini" @click.stop="addIndicator">新增指标</el-button>
              <el-button size="mini" @click.stop="quickCreate">快捷创建</el-button>
            </div>
          </div>
          <el-table :data="formData.indicators" stripe max-height="400">
            <el-table-column
              label="序号"
              type="index"
              width="60"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="pathId" label="路线" width="200">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.pathId"
                  size="small"
                  placeholder="请选择路线"
                  :disabled="mode === 'view'"
                >
                  <el-option
                    v-for="item in pathOpts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="routePoints" label="行程积分" width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.routePoints"
                  size="small"
                  placeholder="请输入行程积分"
                  :disabled="mode === 'view'"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="powerFee" label="单边电费" width="200">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.powerFee"
                  size="small"
                  placeholder="请输入单边电费(元)"
                  :disabled="mode === 'view'"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  v-if="mode === 'edit'"
                  type="text"
                  size="small"
                  @click.stop="deleteIndicator(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-collapse-transition>
  </el-card>
</template>

<script>
import { saveOrUpdateContract } from "@/api";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "DriverContractItem",
  props: {
    contract: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: "view" // view/edit
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      pathOpts: (state) => state.pathList
    }),
    isCurrentValid() {
      const { contractOn, contractOff } = this.contract || {};
      if (contractOn && contractOff) {
        const now = moment();
        return (
          moment(contractOn).subtract(1, "day").isBefore(now) &&
          moment(contractOff).add(1, "day").isAfter(now)
        );
      }
      return false;
    }
  },
  data() {
    return {
      formData: { ...this.contract, indicators: this.cloneIndicators(this.contract.indicators) },
      rules: {
        signDate: [{ required: true, message: "请选择合同签订日期", trigger: "change" }],

        contractOn: [{ required: true, message: "请选择合同开始日期", trigger: "change" }],
        contractOff: [{ required: true, message: "请选择合同结束日期", trigger: "change" }],
        deposit: [{ required: true, message: "请输入押金", trigger: "blur" }],
        basePoints: [{ required: true, message: "请输入保底积分", trigger: "blur" }],
        maxLeaveDaysPerMonth: [
          { required: true, message: "请输入每月最大休息天数", trigger: "blur" }
        ],
        baseSalary: [{ required: true, message: "请输入保底收入", trigger: "blur" }]
      }
    };
  },
  watch: {
    contract: {
      handler(val) {
        this.formData = { ...val, indicators: this.cloneIndicators(val.indicators) };
      },
      deep: true
    },
    mode(val) {
      if (val === "edit") {
        this.formData = {
          ...this.contract,
          indicators: this.cloneIndicators(this.contract.indicators)
        };
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.$emit("toggleCollapse");
    },

    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (!this.validateIndicators()) {
            return;
          }
          saveOrUpdateContract(this.formData).then((res) => {
            this.$emit("save", res.data);
            this.$message.success("保存成功");
          });
        }
      });
    },

    cancel() {
      this.$emit("cancel");
    },
    edit() {
      this.$emit("edit");
    },
    deleteItem() {
      if (this.contract.id) {
        this.$message.warning("已创建的合同无法删除");
      } else {
        this.$emit("delete");
      }
    },
    addIndicator() {
      if (!Array.isArray(this.formData.indicators)) {
        this.$set(this.formData, "indicators", []);
      }
      this.formData.indicators.push({
        pathId: null,
        routePoints: null,
        powerFee: null
      });
    },
    quickCreate() {
      const presets = [
        { pathId: 6, routePoints: 90, powerFee: 45 },
        { pathId: 7, routePoints: 90, powerFee: 45 },
        { pathId: 17, routePoints: 50, powerFee: 23 },
        { pathId: 18, routePoints: 50, powerFee: 23 }
      ];
      this.$set(
        this.formData,
        "indicators",
        presets.map((item) => ({ ...item }))
      );
    },
    deleteIndicator(index) {
      this.$confirm("确认删除该指标吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.formData.indicators.splice(index, 1);
      });
    },
    validateIndicators() {
      const list = this.formData.indicators || [];
      const hasEmptyPath = list.some((item) => !item.pathId);
      if (hasEmptyPath) {
        this.$message.error("请选择路线");
        return false;
      }
      return true;
    },
    cloneIndicators(list) {
      return Array.isArray(list) ? list.map((item) => ({ ...item })) : [];
    }
  }
};
</script>
<style lang="less" scoped>
.contract-item {
  margin-bottom: 16px;
}

.contract-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.contract-title {
  flex: 1;
}

.status {
  margin-left: 12px;
  font-size: 14px;
  padding: 2px 8px;
  border-radius: 4px;
  color: #fff;

  &.active {
    background: #67c23a;
  }

  &.inactive {
    background: #f56c6c;
  }
}

.contract-body {
  margin-top: 16px;
}

.indicator-section {
  margin-top: 24px;
}

.indicator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 600;
}

.mx-2 {
  margin: 0 8px;
}

.arrow-icon {
  margin-left: 8px;
  font-size: 16px;
  display: inline-block;
  transition: transform 0.2s;

  &.rotated {
    transform: rotate(180deg);
  }
}
</style>
